import { CacheService } from './../../../../../shared/services/cache.service';
import { Router } from '@angular/router';
import { SharedService } from './../../../../../shared/services/shared.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Category } from '../../../../admin-panel/components/pages/category/models/category';
import { AuthService } from '../../../../auth/services/auth.service';
import { Permission } from '../../../../../shared/models/permission';
import { AppRoutesUtils } from '../../../../../utils/app-routes-util';
import { EventCategory } from '../../../../admin-panel/components/pages/event-category/models/event-category';
import { firstValueFrom, take } from 'rxjs';

@Component({
  selector: 'app-footer',
  standalone:false,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  isUserLogin!:boolean;
  isContribitor!:boolean;
  key:string='categories';
  categories:Category[]=[];
  eventCategories:EventCategory[]=[];

  constructor(
    private sharedService:SharedService,
    private router:Router,
    private cacheService:CacheService,
    private cdr:ChangeDetectorRef,
    private authService:AuthService
  ) {


  }
  ngOnInit(): void {
    this.isContribitor=this.authService.hasPermission(Permission.Contributor);
    this.isUserLogin=this.sharedService.getAuthFromLocalStorage()!==undefined;
    this.getCategoriesFromCache();
    this.getEventCategoriesFromCache();
  }
  navigateToPlansAndPricing():void{
    const url:string=this.isUserLogin ? '/profile/pricing': '/pricing';
    this.router.navigate([url]);
  }
  navigate(item:Category):void{
    AppRoutesUtils.Pack.navigateToPackGallery(item);
  }

  getPackGalleryPath(item:Category):string[] | null{
    return AppRoutesUtils.Pack.getPackGalleryPath(item);
  }
getEventPackGalleryPath(item:string):string[] | null{
    return AppRoutesUtils.Pack.getEventPackGalleryPath(item);
  }
  async getCategoriesFromCache(){
    await this.cacheService.getCategoriesFromCache().subscribe((response:Category[])=>{
       this.categories=response;
       this.cdr.detectChanges();

     },
     (error)=>{
       console.error(error);
     });
   }
  async getEventCategoriesFromCache(){
    await this.cacheService.getEventCategoriesFromCache().subscribe((response:EventCategory[])=>{
       this.eventCategories=response;
       this.cdr.detectChanges();
     },
     (error)=>{
       console.error(error);
     });
   }

}
